module.exports = __webpack_public_path__ + "img/photo2.cd7c72f8.png";